<template>
  <LFilter class="RSList">
    <template slot="filter">
      <Select :width="'200px'" :defaultValue="page" @input="page=$event">
        <option v-for="i in 4" :key="i" :value="i" :disabled="!info[`sticker_${i}`]">標籤機{{i}}</option>
      </Select>
      <RoundBtn @click="specifys=info[`sticker_list_${page}`];addproduct=true" :bg="'var(--color-pri)'" :text="'加入品項'" :icon="'add'" :style="{paddingInline:'1.2em', marginLeft: 'auto'}"/>
    </template>
    <template v-if="info[`sticker_${page}`]">
      <div class="RSInfo">{{info[`sticker_${page}`].name}} <span :style="{fontSize: '20px'}">{{info[`sticker_${page}`].printer}}</span></div>
      <div class="RSProdList" v-if="info[`sticker_${page}`].name">
        <div class="RSL" v-for="(item, it) in info[`sticker_list_${page}`]" :key="`RSL-${it}`">
          <div>{{products[item]?.name}}</div>
          <div :style="{marginLeft: 'auto'}">${{products[item]?.price}}</div>
          <button @click="deleteItem={name:products[item]?.name, _id:item, index: it}"><svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group"><path id="Vector" d="M12.5002 0.5C5.59644 0.5 0 6.09644 0 13.0002C0 19.9036 5.59644 25.5 12.5002 25.5C19.4036 25.5 25 19.9036 25 13.0002C24.9918 6.09999 19.4004 0.508162 12.5002 0.5ZM12.5002 23.4841C6.70998 23.4841 2.01629 18.7904 2.01629 13.0002C2.01629 7.20998 6.70998 2.51629 12.5002 2.51629C18.29 2.51629 22.9841 7.20998 22.9841 13.0002C22.9773 18.7875 18.2875 23.4773 12.5002 23.4841ZM16.9912 8.50876C16.5977 8.11522 15.9593 8.11522 15.5658 8.50876L12.5002 11.5744L9.43493 8.50876C9.18014 8.25397 8.80896 8.15461 8.46084 8.24794C8.11273 8.34127 7.84091 8.61308 7.74794 8.96084C7.65461 9.30896 7.75433 9.68014 8.00876 9.93493L11.0744 13.0002L8.00876 16.0654C7.61771 16.4593 7.61877 17.0956 8.0116 17.488C8.40407 17.8809 9.04033 17.8819 9.43422 17.4909L12.5002 14.4256L15.5654 17.4912C15.9597 17.8823 16.5956 17.8812 16.988 17.4884C17.3805 17.0959 17.3819 16.4597 16.9905 16.0658L13.9256 13.0002L16.9912 9.93493C17.1804 9.74579 17.2868 9.48958 17.2868 9.22202C17.2868 8.95446 17.1807 8.6979 16.9912 8.50876Z" fill="var(--color-checked)"/></g></svg></button>
        </div>
      </div>
    </template>
    <DialogDef2 :show="addproduct" :label="'指定商品'"  @close="addproduct=false;filCate=null;filText=null" :width="537" :haadBg="'#517FA4'">
      <div class="pointingProduct">
        <div class="fil">
          <Select :width="'200px'" :defaultValue="filCate" @input="filCate=$event">
            <option :value="null">全部類別</option>
            <option v-for="({category}, c) in Sets" :key="`fil-category-${c}`" :value="category">{{category}}</option>
          </Select>
          <SearchVue :width="'260px'" :defaultValue="filText" @input="filText=$event"/>
        </div>
        <div class="list">
          <div v-for="(setGroup, sg) in Sets"  :key="`sg-${sg}`" :label="setGroup.category">
            <template v-if="(!filCate||filCate===setGroup.category)">
              <div class="setTitle" v-if="!filText||setGroup.items.filter(({name}) => new RegExp(filText, 'ig').test(name)).length>0"
                 :style="{fontWeight: '900'}">
                <button class="selectAll" @click="specifys=Array.from(new Set([...specifys, ...setGroup.items.map(e => e._id)]))"
                  v-if="!filText">全選</button>
                  {{setGroup.t==='single'?'-----':'====='}} {{setGroup.category}} {{setGroup.t==='single'?'-----':'====='}}
                <button class="selectAll right" @click="specifys=specifys.filter(e => !setGroup.items.map(a => a._id).includes(e))"
                  v-if="!filText">全不選</button>
              </div>
              <template v-for="({_id, name}, s) in setGroup.items">
              <div class="setli" :key="`set-${s}`" v-if="!filText||new RegExp(filText, 'ig').test(name)">
                <label :for="_id">
                  <input type="checkbox"  :value="_id" v-model="specifys" :id="_id">
                  {{name}}
                </label>
              </div>
              </template>
            </template>
          </div>
        </div>
        <BtnsS @cancel="addproduct=false;filCate=null;filText=null" @save="update" :save="'確定'"/>
      </div>
    </DialogDef2>
    <comfirmVue :show="!!deleteItem"  v-if="!!deleteItem" :label="'確認刪除'" :text='`確定要刪除"${deleteItem.name}"嗎?`'
    @confirm="remove(deleteItem)" @cancel="deleteItem=null"/>
  </LFilter>
</template>

<script>
import SearchVue from '../../../components/input/search.vue'
import RoundBtn from '../../../components/btn/round.vue'
import Select from '../../../components/select.vue'
import LFilter from '../../../components/layout/LaTable.vue'
import { deleteapi, getapi, postapi } from '../../../store/fetch'
export default {
  components: { LFilter, Select, RoundBtn, SearchVue },
  props: ['info', 'restaurant'],
  data () {
    return {
      page: 1,
      addproduct: false,
      filCate: null,
      filText: null,
      specifys: [],
      Sets: [],
      deleteItem: null
    }
  },
  async mounted () {
    this.Sets = await getapi('rest_product/category')
  },
  computed: {
    products () {
      if (this.Sets && this.Sets.length > 0) {
        return Object.assign(...[].concat(...this.Sets.map(e => e.items)).map(e => { return { [e._id]: e } }))
      } else {
        return {}
      }
    }
  },
  methods: {
    async remove ({ _id }) {
      const r = await deleteapi(`restaurantSetting/${this.restaurant}/remove/${this.page}/${_id}`)
      if (r) {
        this.info[`sticker_list_${this.page}`] = r
        this.deleteItem = null
      }
    },
    async update () {
      const r = await postapi(`restaurantSetting/${this.restaurant}`, { [`sticker_list_${this.page}`]: JSON.parse(JSON.stringify(Array.from(new Set(this.specifys)))) })
      if (r) {
        this.$emit('refresh')
        this.addproduct = false
        this.filCate = null
        this.filText = null
      }
    }
  }

}
</script>
<style lang="scss" scoped>
.RSProdList {
  margin-top: 22px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.RSL {
  display: flex;
  align-items: center;
  width: 420px;
  height: 70px;
  padding: 10px 20px;
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
  border-radius: 3px;
  border: 1.5px solid var(--color-checked);
  color:#6D6D6D;
  font-family: Noto Sans TC;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1.8px;
  button {
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      margin: auto;
    }
  }
}
.RSList {
  height: calc(100vh - 90px);
}
.RSInfo {
  color: var(--color-pri);
  font-family: Noto Sans TC;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 2.4px;
  text-align: start;
}
.selectAll {
  color: #FFF;
  text-align: center;
  font-family: Noto Sans TC;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1.6px;
  background-color: var(--highlight);
  display: flex;
  height: 30px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 69px;
  border-radius: 3px;
  position: absolute;
  top: 0;
  left: 0;
  &.right {
    left: auto;
    right: 0;
    background-color: #CACACA;
  }
}
.fil {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 31px 10px 26px;
  background: #E9F5FC;
}
.list {
  overflow-y: auto;
  margin-inline: 5px;
  padding-inline: 26px;
}
.pointingProduct {
  display: grid;
  grid-template-rows: 70px 1fr 70px;
  gap: 10px;
  max-height: 700px;
}
.setTitle {
  font-size: 20px;
  letter-spacing: .3em;
  position: relative;
}
.setli {
  width: 100%;
  label {
    width: 100%;
    display: inline-flex;
    gap: 15px;
    font-size: 20px;
    accent-color: var(--color-pri);
    height: 65px;
    align-items: center;
    color: #787878;
    input[type=checkbox] {
      appearance: none;
      width: 30px;
      height: 30px;
      background-color: #FFFFFF;
      border: 1px solid var(--color-pri);
      border-radius: 5px;
      &:checked {
        background-color: var(--color-pri);
        background-image: url(/svg/checkbox/checkmark.svg);
        background-position: center;
        background-repeat: no-repeat;

      }
    }
  }
}
</style>
<style lang="scss">
.RSList {
  .LaTable-body {
    max-height: calc(100vh - 160px);
    padding: 15px 51px 50px;
  }
  .filter {
    padding-inline: 51px;
    background-color: var(--color-bar);
  }
}
</style>
